import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const ArrowDownAZIcon = memo(({ className, ...props }: SvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            className={className}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M7.00017 3C7.55242 3.00004 8.00017 3.44774 8.00017 4V17.5859L10.2931 15.293C10.6837 14.9025 11.3167 14.9025 11.7072 15.293C12.0976 15.6835 12.0976 16.3165 11.7072 16.707L7.7072 20.707C7.66067 20.7536 7.60881 20.7944 7.55388 20.8311C7.51475 20.8572 7.47445 20.8804 7.43279 20.9004C7.38729 20.9223 7.34018 20.9412 7.29118 20.9561C7.27445 20.9611 7.25734 20.9646 7.2404 20.9688C7.2248 20.9726 7.20941 20.9774 7.19353 20.9805C7.18643 20.9819 7.17916 20.9822 7.17204 20.9834C7.1161 20.9931 7.05889 21 7.00017 21L6.89763 20.9951C6.87615 20.9929 6.85521 20.9879 6.83415 20.9844C6.82375 20.9826 6.81326 20.9816 6.8029 20.9795C6.7914 20.9772 6.78008 20.9744 6.76872 20.9717C6.74815 20.9668 6.72749 20.9622 6.7072 20.9561C6.65855 20.9412 6.61176 20.9222 6.56658 20.9004C6.5247 20.8802 6.48381 20.8574 6.4445 20.8311C6.39008 20.7946 6.3393 20.7532 6.29314 20.707L2.29314 16.707C1.90261 16.3165 1.90261 15.6835 2.29314 15.293C2.68367 14.9025 3.3167 14.9025 3.7072 15.293L6.00017 17.5859V4C6.00017 3.44772 6.44788 3 7.00017 3Z"
                fill="currentColor"
            />
            <path
                d="M20.1437 13.0107C20.4734 13.0585 20.7615 13.2687 20.9054 13.5762C21.0699 13.9275 21.0171 14.3426 20.7687 14.6406L17.1359 19H20.0002C20.5524 19 21.0002 19.4477 21.0002 20C21.0002 20.5523 20.5524 21 20.0002 21H15.0002C14.6122 21 14.2595 20.7752 14.0949 20.4238C13.9304 20.0725 13.9832 19.6574 14.2316 19.3594L17.8644 15H15.0002C14.4479 15 14.0002 14.5523 14.0002 14C14.0002 13.4477 14.4479 13 15.0002 13H20.0002L20.1437 13.0107Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5002 3C18.4284 3.00002 19.3184 3.36903 19.9748 4.02539C20.6311 4.68176 21.0002 5.57176 21.0002 6.5V10C21.0002 10.5523 20.5524 11 20.0002 11C19.4479 11 19.0002 10.5523 19.0002 10V9H16.0002V10C16.0002 10.5523 15.5524 11 15.0002 11C14.4479 11 14.0002 10.5523 14.0002 10V6.5C14.0002 5.57174 14.3692 4.68177 15.0256 4.02539C15.6819 3.36904 16.5719 3 17.5002 3ZM17.5002 5C17.1024 5 16.7209 5.15817 16.4396 5.43945C16.1583 5.72076 16.0002 6.10218 16.0002 6.5V7H19.0002V6.5C19.0002 6.10219 18.842 5.72075 18.5607 5.43945C18.2794 5.15817 17.898 5.00002 17.5002 5Z"
                fill="currentColor"
            />
        </svg>
    );
});

ArrowDownAZIcon.displayName = 'ArrowDownAZIcon';
